import styles from './PlacingOrderSelectingDelivery.module.scss';
import cn from 'classnames';
import PlacingOrderButtons from '@components/PlacingOrderButtons';
import PlacingOrderHeader from '@components/PlacingOrderHeader';
import Radio from '@components/new/Radio';
import { createSumFromObject } from '@utils/formatValues';
import { Grid } from '@components/Grid';
import { IPlacingOrderSelectingDeliveryProps, TSelectingDeliveryActions } from '../../types';
import { Text, TextColor, TextSize, TextType, TextWeight } from '@components/Text';
import { useTranslation } from 'react-i18next';

const PlacingOrderSelectingDelivery: React.FC<IPlacingOrderSelectingDeliveryProps> = (props: IPlacingOrderSelectingDeliveryProps): React.ReactElement => {
  const {
    buttons,
    costOfService,
    costOfServiceDifferent,
    deliveryType,
    handlerSetDeliveryType, 
    allowRu
  } = props;

  const { t } = useTranslation();

  const actions: TSelectingDeliveryActions[] = allowRu === undefined || allowRu === null || allowRu ? [
    {
      cost: createSumFromObject({ amount: costOfServiceDifferent, currency: 'CNY' }),
      description: t('placingOrderModalWindow.preselection.actions.description_1'),
      title: t('placingOrderModalWindow.preselection.actions.title_1'),
      type: 'RU'
    },
    {
      cost: createSumFromObject({ amount: costOfService, currency: 'CNY' }),
      description: t('placingOrderModalWindow.preselection.actions.description_2'),
      title: t('placingOrderModalWindow.preselection.actions.title_2'),
      type: 'default'
    }
  ]: [{
    cost: createSumFromObject({ amount: costOfService, currency: 'CNY' }),
    description: t('placingOrderModalWindow.preselection.actions.description_2'),
    title: t('placingOrderModalWindow.preselection.actions.title_2'),
    type: 'default'
  }];

  return (
      <Grid>
        <PlacingOrderHeader title={t('placingOrderModalWindow.headline.preselection')}/>
        deliveryType - {deliveryType}
        <div className={styles.actions}>
          {actions.map((item: TSelectingDeliveryActions, index: number) => (
              <button
                  className={cn(styles.action, deliveryType === item.type && styles.actionSelected)}
                  key={index}
                  onClick={() => handlerSetDeliveryType(item.type)}
              >
                <div className={styles.actionName}>
                  <Radio
                    checked={deliveryType === item.type}
                  />
                  <div className={styles.actionTitle}>
                    <Text
                        color={TextColor.PRIMARY}
                        size={TextSize.M}
                        type={TextType.SPAN}
                        weight={TextWeight.SEMIBOLD}
                    >
                      {item.title}
                    </Text>
                    <Text
                        color={TextColor.PRIMARY}
                        size={TextSize.S}
                        type={TextType.SPAN}
                    >
                      {item.description}
                    </Text>
                  </div>
                </div>
                <Text
                    color={TextColor.PRIMARY}
                    size={TextSize.XL}
                    weight={TextWeight.MEDIUM}
                >
                  <span className={styles.actionCost}>
                    {item.cost}
                  </span>
                </Text>
              </button>
          ))}
        </div>
        <PlacingOrderButtons buttons={buttons}/>
      </Grid>
  );
};

export default PlacingOrderSelectingDelivery;
